import { List } from "@mui/material";
import { BeautifulMentionsMenuProps } from "lexical-beautiful-mentions";
import { omit } from "lodash";
import { forwardRef } from "react";

export const LexicalEditorMentionsMenu = forwardRef<HTMLUListElement, BeautifulMentionsMenuProps>((props, ref) => {
  return (
    <List
      key={props.helperText}
      component="ul"
      sx={{
        zIndex: 1000000,
        top: "20px",
        backgroundColor: "#f5f5f5",
        padding: "4px",
        borderRadius: "2px",
        maxHeight: "200px",
        overflowY: "scroll",
        minWidth: "200px",
        width: "fit-content",
      }}
      ref={ref}
      {...omit(props, ["open", "loading"])}
    />
  );
});
